<template>
  <div>
    <add-drug class="my-2 pb-6 px-2 pt-2" v-if="isAdding" @updateDrugs="updateDrugs" :drugs="isAdding ? [] : drugs" :customerId="customer.customerId"/>        
    <div v-else class="flex flex-row bg-white mt-1">
      <table class="flex flex-col min-w-full max-w-full overflow-y-auto p-2">
        <tr class="flex flex-row bg-white mb-2 rounded-tl rounded-tr items-center justify-center">
            <th class="text-sm font-semibold text-grey-dark mr-auto">CURRENT MEDICATIONS</th>
            <th class="justify-center cursor-pointer text-blue text-sm font-semibold ml-auto mr-1" @click="addDrug()">+ Add Medication</th>
        </tr>
        <tr v-if="medications.length>0" class="flex flex-row h-10 p-2 items-center border-solid border-b border-grey-lightest bg-grey-extralight text-sm text-grey-dark text-left">
          <th class="text-grey-darker font-semibold w-4/5">Drug</th>
          <th class="text-grey-darker font-semibold w-2/5">Dosage</th>
          <th class="text-grey-darker font-semibold w-2/5">Frequency</th>
          <th class="text-grey-darker font-semibold w-2/5 pl-4">Duration</th>
          <th class="text-grey-darker font-semibold w-1/5">Action</th>
          <!-- <th class="w-1/5"></th> -->
        </tr>
        <tr v-for="(med,index) in medications" :key="index" class="flex flex-row h-10 p-2 bg-grey-extralight text-sm text-grey-darker text-left">
          <td class="text-grey-darker w-4/5 truncate">{{med.name}}</td>
          <td class="text-grey-darker w-2/5">{{med.dose_quantity}} {{med.dose_unit}}</td>
          <td class="text-grey-darker w-2/5 text-center">{{med.frequency}}</td>
          <td v-if="med.duration&&med.duration_unit" class="text-grey-darker w-2/5 pl-4 text-center">{{med.duration}} {{med.duration_unit}}</td>
          <td v-else class="text-grey-darker w-2/5 pl-4 text-center">{{med.number_of_days}} days</td>
          <td @click="deleteDrug(med, index)" class="text-grey-darker w-1/5 text-center self-center"><img class="w-4" src="../../assets/delete.png"></td> 
        </tr>
      </table>
    </div>
    <div v-if="showDeleteWarning">
      <div id="overlay" @click="closeEndChatOverlay()" style="position: fixed; width: 100%; height: 100%; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0.5); z-index: 10; cursor: pointer;"></div>
      <!--VALID Confirmation pop up when ending consultation-->
      <div class="absolute flex flex-col bg-white shadow rounded-sm h-auto z-20" style="width: 600px; left: calc((100vw - 600px)/2); top:150px;">
        <div class="flex flex-col justify-center px-4 py-2 border-b border-solid border-grey-lightest">
          <div class="flex flex-row mb-2 justify-between items-center">
            <div class="align-center text-m text-left font-semibold py-2">Delete medication</div>
          </div>
          <label class="text-grey-darker font-light text-xs">Are you sure you want to delete this medicine from current medication?</label>
          <div class="flex flex-row mt-3 mb-2 justify-start">
            <div v-on:click="deleteHandler()" class="flex flex-col bg-blue px-6 py-2 justify-center cursor-pointer rounded-sm text-white text-sm hover:shadow-md">Delete</div>
            <div v-on:click="closeEndChatOverlay()" class="flex flex-col bg-grey-light ml-4 px-4 py-2 justify-center cursor-pointer rounded-sm text-grey-dark text-sm hover:shadow-md">Cancel</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextField from '@/components/common/TextField'
import AddDrug from '@/components/Customer/AddDrug'
import {mapGetters} from 'vuex'
export default {
  components: {
    TextField,
    AddDrug
  },
  props: ['chatType'],
  data () {
    return {
      isEditing: false,
      isAdding: false,
      recommendations: null,
      drugs: [],
      showDeleteWarning: false,
      selectedMed: {}
    }
  },
  computed: {
    ...mapGetters({
      customer: 'configuration/getActivePatientProfile',
      activeSection: 'configuration/getActiveSection'
    }),
    medications: function () {
      if (this.customer && this.customer.details && this.customer.details.medications) {
        return this.customer.details.medications
      }
      return []
    }
  },
  watch: {
    customer: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.isAdding = false
      }
    }
  },
  methods: {
    closeEndChatOverlay: function () {
      this.showDeleteWarning = false
    },
    editDrugs: function () {
      this.isEditing = true
    },
    addDrug: function () {
      this.isAdding = true
    },
    saveClicked: function () {
      this.isEditing = false
      this.isAdding = false
    },
    cancelClicked: function () {
      this.isEditing = false
      this.isAdding = false
    },
    updateDrugs: function (data) {
      if (data) {
        if (this.chatType === 'offline') {
          if (this.isAdding) {
            this.drugs.push(data)
          }
          if (this.activeSection === 'consults') {
            this.$store.dispatch('pastOfflineConsultation/updateCurrentMedication', this.drugs)
          } else if (this.activeSection === 'connected') {
            this.$store.dispatch('offlineConsultation/updateCurrentMedication', this.drugs)
          }
        } else if (this.chatType === 'online') {
          if (this.isAdding) {
            this.drugs.push(data)
          }
          if (this.activeSection === 'consults') {
            this.$store.dispatch('pastConsultation/updateCurrentMedication', this.drugs)
          } else if (this.activeSection === 'connected') {
            this.$store.dispatch('consultation/updateCurrentMedication', this.drugs)
          }
        }
      }
      this.isEditing = false
      this.isAdding = false
    },
    deleteDrug: function (med, index) {
      this.showDeleteWarning = true
      this.selectedMed = med
    },
    deleteHandler: function () {
      if (this.chatType === 'offline') {
        this.$store.dispatch('offlineConsultation/updateCurrentMedication', [this.selectedMed])
      } else if (this.chatType === 'online') {
        this.$store.dispatch('consultation/updateCurrentMedication', [this.selectedMed])
      }
      this.showDeleteWarning = false
      this.selectedMed = {}
    }
  }
}
</script>

<style>
th {
  font-weight: normal
}
</style>



// WEBPACK FOOTER //
// src/components/Customer/CurrentMedication.vue